import React from "react";

export const RightNotes = ({ notes }) => {
  return (
    <div>
      {Array.isArray(notes) ? notes.map((note, index) => (
        <div key={index} className="noteInfoContainer">
          <div className="noteInfoHeader">{note.updatedByFullName}</div>
          {note.createdDate && (
            <div className="noteInfoDate">{note.createdDate}</div>
          )}
          {note.noteType && <div className="noteType">{note.noteType}</div>}
          {note.notes && <div className="perdefinedNote">{note.notes}</div>}
          {note.customNotes && (
            <div className="customNote">{note.customNotes}</div>
          )}
        </div>
      )) : ''}
    </div>
  );
};

export default RightNotes;
